import api from "./api";

export const getFunnels = () => {
    return api.get("/funnels");
};

export const getFunnel = (id) => {
    return api.get(`/funnels/${id}`);
};

export const createFunnel = (data) => {
    return api.post("/funnels", data);
};

export const updateFunnel = (id, data) => {
    return api.put(`/funnels/${id}`, data);
};

export const deleteFunnel = (id) => {
    return api.delete(`/funnels/${id}`);
};
